import useTypedSWR from 'src/components/general/useTypedSWR';
import { MDT_REFRESH_INTERVAL } from 'src/myDayToday/constants';
import { GET_MY_DAY_TODAY_VISITS_QUERY } from 'src/myDayToday/hooks/useMyDayTodayVisits.gql';

export function useMyDayTodayVisits(providerId: string | null | undefined) {
  const { data, isLoading, error, mutate } = useTypedSWR(
    providerId ? [GET_MY_DAY_TODAY_VISITS_QUERY, { providerId }] : null,
    {
      keepPreviousData: true,
      refreshInterval: MDT_REFRESH_INTERVAL,
      refreshWhenHidden: true,
      revalidateIfStale: true,
    },
  );

  return {
    acceptNextPatientSection: data?.staff_getAcceptNextPatientSection ?? null,
    unsignedVisits: data?.staff_getProviderUnsignedVisits ?? [],
    isLoading,
    error,
    mutate,
  };
}
